<template>
  <div class="flex min-h-screen items-center justify-center bg-gray-900 text-gray-400">
    <Loader2 size="36" class="text-primary animate-spin" />
  </div>
</template>

<script setup>
import { Loader2 } from 'lucide-vue-next';
</script>
